import { useMemo } from 'react';
import useGym from './use_gym';

const usePaymentMethods = () => {
  const gym = useGym();

  const paymentMethods = useMemo(() => {
    const bankAccountLabel = (() => {
      switch (true) {
        case gym.bank_account_provider === 'bluefin':
          return 'Check';
        case gym.bank_account_provider === 'integrapay' && gym.country === 'US':
          return 'Check';
        case gym.country === 'GB' && gym.bank_account_provider === 'gocardless':
          return 'Mandate';
        default:
          return 'Bank Account';
      }
    })();

    const bankAccount = { value: 'bank_account', label: bankAccountLabel };
    const creditCard = { value: 'credit_card', label: 'Credit Card' };
    const noPaymentMethod = { value: 'no_payment_method', label: 'No payment method' };

    return (() => {
      switch (true) {
        case !!(gym.credit_card_provider && gym.bank_account_provider):
          return [noPaymentMethod, bankAccount, creditCard];
        case !!gym.credit_card_provider:
          return [noPaymentMethod, creditCard];
        case !!gym.bank_account_provider:
          return [noPaymentMethod, bankAccount];
        default:
          return [];
      }
    })();
  }, [gym]);

  return paymentMethods;
};

export default usePaymentMethods;
